import { overrideWidgetSectionConfig, getCustomValueTemplates } from './utils';
import { DEFAULT_CHART_VALUE_TEMPLATE } from '@/config/widget'; // Transform active chart section to bar chart

const chartAdapter = (sectionId, widget) => {
  const {
    xAxisTemplate,
    yAxisTemplate,
    globalSeriesTemplate
  } = getCustomValueTemplates(sectionId, widget);
  return overrideWidgetSectionConfig(sectionId, widget, 'BarChart', {
    selectionsStrategy: 'groups',
    selectionsLabeled: false,
    hasLegend: false,
    chartType: undefined,
    yAxisTemplate: yAxisTemplate || xAxisTemplate || globalSeriesTemplate || DEFAULT_CHART_VALUE_TEMPLATE
  });
};

export default chartAdapter;